// src/config/facturasTimbradasColumns.js
// Columnas de la vista de facturas timbradas (consulta con ConTimbre=true).
// Esquema tomado del Manual Web API SFTF V1.1, sección 1, "datos de facturación
// con timbre", y verificado contra la respuesta real del servicio.

export const FACTURAS_TIMBRADAS_COLUMNS = [
  { id: 'ClaveFactura', label: 'Clave Factura', minWidth: 130, sortable: true },
  { id: 'SerieBitacora', label: 'Serie Bitácora', minWidth: 130, sortable: true },
  { id: 'FolioBitacora', label: 'Folio Bitácora', minWidth: 130, sortable: true },
  { id: 'ClaveBitacora', label: 'Clave Bitácora', minWidth: 130, sortable: true },
  { id: 'SerieFactura', label: 'Serie Factura', minWidth: 120, sortable: true },
  { id: 'FolioFactura', label: 'Folio Factura', minWidth: 120, sortable: true },
  { id: 'FechaFactura', label: 'Fecha Factura', minWidth: 180, sortable: true },
  { id: 'UUID', label: 'UUID', minWidth: 300, sortable: true },
  { id: 'TipoFactura', label: 'Tipo Factura', minWidth: 120, sortable: true },
  { id: 'ClaveTipoFactura', label: 'Clave Tipo Factura', minWidth: 150, sortable: true },
  { id: 'Moneda', label: 'Moneda', minWidth: 100, sortable: true },
  { id: 'TipoCambio', label: 'Tipo Cambio', minWidth: 120, sortable: true },
  { id: 'SubTotal', label: 'Subtotal', minWidth: 130, sortable: true },
  { id: 'Total', label: 'Total', minWidth: 130, sortable: true },
  { id: 'Estatus', label: 'Estatus', minWidth: 150, sortable: true },
  { id: 'SerieRemision', label: 'Serie Remisión', minWidth: 130, sortable: true },
  { id: 'FolioRemision', label: 'Folio Remisión', minWidth: 130, sortable: true },
  { id: 'RemitenteRFC', label: 'RFC Remitente', minWidth: 150, sortable: true },
  { id: 'UsuarioCreacion', label: 'Usuario Creación', minWidth: 160, sortable: true },
  { id: 'FechaCreacion', label: 'Fecha Creación', minWidth: 180, sortable: true },
  { id: 'RutaXML', label: 'Ruta XML', minWidth: 320, sortable: true },
  { id: 'RutaPDF', label: 'Ruta PDF', minWidth: 320, sortable: true },
];

export const FACTURAS_TIMBRADAS_DATE_COLUMN_IDS = ['FechaFactura', 'FechaCreacion'];

/**
 * Devuelve la etiqueta legible del estatus de una factura.
 *
 * El servicio devuelve `EstatusFactura` en null en todos los registros del
 * listado masivo, pero `Estatus` sí trae la clave entera. Por eso la etiqueta
 * se deriva del catálogo de estatus.
 *
 * @param {Object} registro Registro de factura timbrada.
 * @param {Array<Object>} catalogoEstatus Catálogo de EstatusFactura/Consultar.
 * @returns {String}
 */
export const etiquetaEstatusFactura = (registro, catalogoEstatus = []) => {
  if (registro?.EstatusFactura) return registro.EstatusFactura;

  const clave = Number(registro?.Estatus);
  if (registro?.Estatus === null || registro?.Estatus === undefined || Number.isNaN(clave)) {
    return '-';
  }

  const encontrado = (catalogoEstatus || []).find(
    (estatus) => Number(estatus?.ClaveEstatusFactura) === clave
  );
  return encontrado ? encontrado.EstatusFactura : String(clave);
};

/**
 * Valor de una celda tal y como debe verse en la tabla y exportarse a Excel.
 *
 * @param {Object} registro Registro de factura timbrada.
 * @param {String} columnId Identificador de la columna.
 * @param {Array<Object>} catalogoEstatus Catálogo de estatus.
 * @returns {String|Number}
 */
export const valorCeldaFacturaTimbrada = (registro, columnId, catalogoEstatus = []) => {
  if (columnId === 'Estatus') {
    return etiquetaEstatusFactura(registro, catalogoEstatus);
  }

  const raw = registro?.[columnId];

  if (FACTURAS_TIMBRADAS_DATE_COLUMN_IDS.includes(columnId)) {
    return raw ? new Date(raw).toLocaleString() : '-';
  }

  return raw ?? '-';
};
